import { useQuery } from "react-query";
import { get } from "shared/data";
import { getProductName } from "shared/product-name";

export const useMainWipProductName = (codingWipKey, { enabled = true } = {}) => {
    return useQuery({
        queryKey: ["mainWipProductName", codingWipKey],
        queryFn: () => get(`/coding/wips/${codingWipKey}`, { defaultReturn: {} }).then(getProductName),
        enabled: Boolean(codingWipKey) && enabled,
        staleTime: 60 * 1000,
        retry: false,
    });
};
